/**
 * -----------------------------------------------------------------------------
 * It renders the GradeReviewSummaryIcon icon
 */
export function GradeReviewSummaryIcon() {
  return (
    <svg
      className="size-8"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M10 3.496H4.996a2 2 0 0 0-2 2.001V10.5a2 2 0 0 0 2 2.001H10a2 2 0 0 0 2.001-2V5.496a2 2 0 0 0-2-2Z" />

      <path d="M5.997 6.623H9m-1.502 0v2.75M21.004 12H15m6.004-4.002H15m6.004-4.001H15m6.004 16.006H2.996m18.008-4.001H2.996" />
    </svg>
  );
}
